module.exports = __webpack_public_path__ + "static/media/about-mobile.dafaf4be.svg";